export const SET_BOOKING = "SET_BOOKING";
export const SET_CURRENT_MATSPEC = "SET_CURRENT_MATSPEC";
export const SET_CURRENT_CREATIVE = "SET_CURRENT_CREATIVE";
export const GET_CURRENT_MATSPEC = "GET_CURRENT_MATSPEC";
export const SET_CURRENT_TAB = "SET_CURRENT_TAB";
export const SET_PREFLIGHT_REPORT = "SET_PREFLIGHT_REPORT";
export const MODAL_VISIBLE = "MODAL_VISIBLE";
export const SET_APPROVING = "SET_APPROVING";
export const SET_SUBMITTING = "SET_SUBMITTING";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
export const SET_BOOKING_TYPE = "SET_BOOKING_TYPE";
export const SET_FIELD_TRANSLATIONS = "SET_FIELD_TRANSLATIONS";
export const TOGGLE_SPLASH = "TOGGLE_SPLASH";
export const SET_ADMATERIAL = "SET_ADMATERIAL";
export const SET_TRANSLATIONS = "SET_TRANSLATIONS";
export const SET_FIELDS_TO_SAVE = "SET_FIELDS_TO_SAVE";
export const SET_MATSPECS_TO_SUBMIT = "SET_MATSPECS_TO_SUBMIT";



// WEBPACK FOOTER //
// ./src/redux/constants.js